import React, { Component } from "react";
import {
  GET,
  GET_FILE,
  alert,
  saveAs,
  loading,
  Modal,
  NavbarCustomer,
  Pagination,
  t,
  sortOptions,
} from "../../components/CustomComponent.js"; // ปรับ Path ให้ตรงกับโปรเจกต์ของคุณ
import { getProfile } from "../../utils/localStorage";
import { isCustomerScopeReady } from "../../utils/customerScope";
import { REPORT_PERIODS, formatDate, statusColor, translateKey } from "../../utils/customerReport";

const PAGE_SIZE = 10;

// ดาวคะแนนแบบ SVG: ฟอนต์ไอคอนของระบบมีแค่ FontAwesome Light (เส้นขอบ) ดาวเต็ม \uf005 จึงเรนเดอร์เป็นเส้นขอบเหมือน \uf006
// ปัดคะแนนเป็นครึ่งดวงที่ใกล้สุด (4.3 -> 4.5, 4.2 -> 4.0)
const STAR_PATH = "M12 2.5l2.94 5.96 6.58.96-4.76 4.64 1.12 6.55L12 17.5l-5.88 3.09 1.12-6.55L2.48 9.42l6.58-.96z";
const STAR_FILL = "#F59E0B";
const STAR_EMPTY = "#D1D5DB";
const StarRating = ({ rating, size = 16 }) => {
  const value = Math.max(0, Math.min(5, Math.round(Number(rating) * 2) / 2 || 0));
  return (
    <span className="d-inline-flex align-items-center" role="img" aria-label={`${Number(rating).toFixed(1)} / 5`}>
      {[0, 1, 2, 3, 4].map((i) => {
        const fill = value >= i + 1 ? 1 : value >= i + 0.5 ? 0.5 : 0;
        const gradId = `star-half-${i}-${size}`;
        return (
          <svg key={i} width={size} height={size} viewBox="0 0 24 24" aria-hidden="true">
            {fill === 0.5 && (
              <defs>
                <linearGradient id={gradId}>
                  <stop offset="50%" stopColor={STAR_FILL} />
                  <stop offset="50%" stopColor={STAR_EMPTY} />
                </linearGradient>
              </defs>
            )}
            <path
              d={STAR_PATH}
              fill={fill === 1 ? STAR_FILL : fill === 0.5 ? `url(#${gradId})` : STAR_EMPTY}
              stroke={fill === 0 ? STAR_EMPTY : STAR_FILL}
              strokeWidth="1"
              strokeLinejoin="round"
            />
          </svg>
        );
      })}
    </span>
  );
};

export default class ServiceHistory extends Component {
  constructor(props) {
    super(props);
    this.state = {
      // -----------------------------------
      // Filter States
      // -----------------------------------
      filter_search: "",
      filter_asset: "",
      filter_category: "",
      filter_period: "last_12_months",

      count: 0,
      page: 1,

      summary: {
        total_services: 0,
        completed: 0,
        follow_up: 0,
        avg_rating: null
      },

      lookups: { assets: [], categories: [] },
      exporting: "",
      loaded: false,

      data: [],

      modal_view: false,
      view_item: null,
      view_loading: false,
    };
  }

  async componentDidMount() {
    if (!isCustomerScopeReady(getProfile())) {
      loading(false);
      return;
    }

    await Promise.all([this.GetLookups(), this.Get(1)]);
    loading(false);
  }

  GetLookups = async () => {
    const result = await GET("customer/reports/lookups");
    if (result?.status === true) this.setState({ lookups: result.data || { assets: [], categories: [] } });
  };

  // ตัวกรองชุดเดียวกันทั้งตอนโหลดตารางและตอนสั่ง export -> ไฟล์ที่ได้ตรงกับที่เห็นบนหน้าจอ
  filterParams = () => ({
    period: this.state.filter_period,
    data_search: this.state.filter_search || "",
    asset_uid: this.state.filter_asset || "",
    category_uid: this.state.filter_category || "",
  });

  Get = async (page = 1) => {
    loading(true);

    const result = await GET("customer/reports/service-history", {
      ...this.filterParams(),
      page,
      page_size: PAGE_SIZE,
    });

    if (result?.status === true) {
      const data = result.data || {};
      this.setState({
        data: Array.isArray(data.data) ? data.data : [],
        summary: data.summary || this.state.summary,
        count: result.pagination?.count || 0,
        page,
        loaded: true
      });
    }

    loading(false);
  };

  onFilterChange = (field, value) => this.setState({ [field]: value }, () => this.Get(1));

  exportFile = async (format) => {
    this.setState({ exporting: format });

    const result = await GET_FILE("customer/reports/service-history/export", {
      ...this.filterParams(),
      format,
      lang: localStorage.getItem("lang") === "EN" ? "en" : "th",
    });

    this.setState({ exporting: "" });

    if (result?.status !== true) {
      alert("", "error", t("error"), result?.message || t("export_failed"));
      return;
    }

    const stamp = new Date().toISOString().slice(0, 10);
    saveAs(result.blob, `service-history_${stamp}.${format === "pdf" ? "pdf" : "xlsx"}`);
  };

  downloadServiceReport = async (item) => {
    if (!item.wo_uid || !item.visit_uid) return;

    loading(true);
    const result = await GET_FILE(`customer/work-orders/${item.wo_uid}/visits/${item.visit_uid}/service-report/pdf`);
    loading(false);

    if (result?.status !== true) {
      alert("", "error", t("error"), result?.message || t("export_failed"));
      return;
    }

    saveAs(result.blob, result.fileName || "service-report.pdf");
  };

  openDetail = async (item) => {
    if (!item.visit_uid) return;

    this.setState({ modal_view: true, view_item: item, view_loading: true });

    const result = await GET(`customer/reports/service-history/${item.visit_uid}`);

    if (result?.status === true) {
      this.setState({ view_item: result.data, view_loading: false });
    } else {
      this.setState({ view_loading: false });
      alert("", "error", t("error"), result?.message || t("export_failed"));
    }
  };

  closeDetail = () => this.setState({ modal_view: false, view_item: null, view_loading: false });

  render() {
    const {
      data, count, page, summary, lookups, filter_search, filter_asset, filter_category, filter_period, exporting, loaded,
      modal_view, view_item, view_loading
    } = this.state;

    return (
      <div className="w-100 min-vh-100" style={{ backgroundColor: "#F4F7FE" }}>
        <NavbarCustomer />
        <div className="body p-4 mt-3">
          
          {/* Header Section */}
          <div className="mb-4">
            <h3 className="fw-bold mb-1 text-dark">{t("service_history")}</h3>
            <div className="text-secondary text-14">{t("history_desc")}</div>
          </div>

          {/* KPI Summary (Top Stats) */}
          <div className="row g-3 mb-4">
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("total_services")}</div>
                    <h3 className="fw-bold mb-0 mt-1">{summary.total_services}</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-primary-light text-primary d-flex align-items-center justify-content-center text-18 icon">{"\uf15b"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("completed")}</div>
                    <h3 className="fw-bold text-success mb-0 mt-1">{summary.completed}</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-success-light text-success d-flex align-items-center justify-content-center text-18 icon">{"\uf058"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("follow_up")}</div>
                    <h3 className="fw-bold text-warning mb-0 mt-1">{summary.follow_up}</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-warning-light text-warning d-flex align-items-center justify-content-center text-18 icon">{"\uf2f1"}</div>
                </div>
              </div>
            </div>
            <div className="col-lg-3 col-md-6">
              <div className="card border-0 rounded-4 shadow-sm p-3 bg-white">
                <div className="d-flex align-items-center justify-content-between">
                  <div>
                    <div className="text-secondary text-12 fw-bold">{t("avg_rating")}</div>
                    <h3 className="fw-bold text-purple mb-0 mt-1">{summary.avg_rating ?? "-"}</h3>
                  </div>
                  <div className="wpx-40 hpx-40 rounded bg-purple-light text-purple d-flex align-items-center justify-content-center text-18 icon">{"\uf005"}</div>
                </div>
              </div>
            </div>
          </div>

          {/* Filter Bar */}
          <div className="bg-white rounded-4 shadow-sm p-3 mb-4 d-flex flex-wrap align-items-center gap-3">
            <div className="position-relative flex-grow-1" style={{ maxWidth: "550px" }}>
              <span className="icon position-absolute top-50 start-0 translate-middle-y ms-3 text-secondary text-12">{"\uf002"}</span>
              <input
                type="text"
                className="form-control ps-5 rounded-3 border-light bg-light"
                placeholder={t("search_history")}
                value={filter_search}
                onChange={(e) => this.setState({ filter_search: e.target.value })}
                onKeyDown={(e) => { if (e.key === "Enter") this.Get(1); }}
              />
            </div>
            <select
              className="form-select wpx-150 rounded-3 border-light fw-bold text-secondary text-13 shadow-none"
              value={filter_asset}
              onChange={(e) => this.onFilterChange("filter_asset", e.target.value)}
            >
              <option value="">{t("all_assets")}</option>
              {sortOptions(lookups.assets, { by: (a) => a.name || a.asset_code }).map((asset) => (
                <option key={asset.uid} value={asset.uid}>{asset.name || asset.asset_code}</option>
              ))}
            </select>
            <select
              className="form-select wpx-180 rounded-3 border-light fw-bold text-secondary text-13 shadow-none"
              value={filter_category}
              onChange={(e) => this.onFilterChange("filter_category", e.target.value)}
            >
              <option value="">{t("all_service_types")}</option>
              {sortOptions(lookups.categories, { by: "name" }).map((category) => (
                <option key={category.uid} value={category.uid}>{category.name}</option>
              ))}
            </select>
            <select
              className="form-select wpx-150 rounded-3 border-light fw-bold text-secondary text-13 shadow-none"
              value={filter_period}
              onChange={(e) => this.onFilterChange("filter_period", e.target.value)}
            >
              {REPORT_PERIODS.map((period) => (
                <option key={period.value} value={period.value}>{t(period.label)}</option>
              ))}
            </select>
            <button
              className="btn btn-primary px-3 fw-bold d-flex align-items-center rounded-3 shadow-sm border-0"
              disabled={!!exporting}
              onClick={() => this.exportFile("excel")}
            >
              <span className="icon me-2">{"\uf019"}</span> {exporting === "excel" ? t("loading") : t("export")}
            </button>
          </div>

          {/* History List */}
          <div className="d-flex flex-column gap-4">
            {data.length === 0 ? (
              <div className="card border-0 rounded-4 shadow-sm bg-white p-5 text-center text-secondary">
                {loaded ? t("no_data") : t("loading")}
              </div>
            ) : data.map((item) => {
              const color = item.needs_followup ? "warning" : "success";
              return (
                <div key={item.visit_uid} className={`card border-0 rounded-4 shadow-sm bg-white overflow-hidden ${item.needs_followup ? 'border-start border-5 border-warning' : ''}`}>
                  <div className="p-4">
                    {/* Card Header */}
                    <div className="d-flex justify-content-between align-items-start mb-3">
                      <div className="d-flex">
                        <div className={`wpx-35 hpx-35 rounded-circle d-flex align-items-center justify-content-center me-3 text-white bg-${color}`}>
                          <span className="icon text-12">{item.needs_followup ? "\uf2f1" : "\uf00c"}</span>
                        </div>
                        <div>
                          <div className="d-flex align-items-center flex-wrap gap-2 mb-1">
                            <h5 className="fw-bold text-dark mb-0">{item.title || "-"}</h5>
                            {/* สถานะงานขึ้นเสมอ ส่วน "ต้องตามงานต่อ" เป็นป้ายเพิ่มอีกใบ - เดิมป้ายตามงานต่อไปทับสถานะจนไม่รู้ว่างานจบหรือยัง */}
                            <span className={`badge bg-${statusColor(item.status)}-light text-${statusColor(item.status)} rounded-1 text-8 fw-bold`}>
                              {translateKey(item.status)}
                            </span>
                            {item.needs_followup && (
                              <span className="badge bg-warning-light text-warning rounded-1 text-8 fw-bold">
                                <span className="icon me-1">{"\uf071"}</span> {t("follow_up_required")}
                              </span>
                            )}
                          </div>
                          <div className="text-secondary text-13">{[item.asset_name, item.location].filter(Boolean).join(" • ") || "-"}</div>
                        </div>
                      </div>
                      <div className="text-end">
                        <div className="text-secondary text-10 font-monospace mb-1">{item.wo_number || "-"}</div>
                        <div className="text-warning text-14">
                          {item.rating === null || item.rating === undefined ? (
                            <span className="text-secondary text-12">{t("not_rated")}</span>
                          ) : (
                            <>
                              <StarRating rating={item.rating} size={16} />
                              <span className="text-secondary text-12 ms-1 fw-bold">{Number(item.rating).toFixed(1)}</span>
                            </>
                          )}
                        </div>
                      </div>
                    </div>

                    {/* Info Icons Bar */}
                    <div className="d-flex align-items-center gap-4 mb-3 text-secondary text-12">
                      <span><span className="icon me-1">{"\uf073"}</span> {formatDate(item.date) || "-"}</span>
                      <span><span className="icon me-1">{"\uf007"}</span> {item.technician_name || "-"}</span>
                      <span><span className="icon me-1">{"\uf017"}</span> {item.duration_text || "-"}</span>
                      <span><span className="icon me-1">{"\uf0ad"}</span> {translateKey(item.type)}</span>
                    </div>

                    {/* Resolution Text */}
                    <div className="bg-light bg-opacity-50 p-3 rounded-3 mb-3">
                      <div className="text-dark fw-bold text-12 mb-1">{t("resolution")}:</div>
                      <div className="text-secondary text-13 lh-base">{item.resolution || "-"}</div>
                      {item.needs_followup && (
                        <div className="mt-2 text-danger fw-bold text-12 d-flex align-items-center">
                          <span className="icon me-1">{"\uf071"}</span> {t("follow_up_required")}
                        </div>
                      )}
                    </div>

                    {/* Badges and Actions */}
                    <div className="d-flex justify-content-between align-items-center">
                      <div className="d-flex gap-2">
                        <span className="badge bg-primary-light text-primary rounded-1 text-10 fw-normal px-2 py-1">{item.parts_used} {t("parts_used")}</span>
                        <span className="badge bg-purple-light text-purple rounded-1 text-10 fw-normal px-2 py-1">{item.photos} {t("photos")}</span>
                        {item.feedback && <span className="badge bg-warning-light text-warning rounded-1 text-10 fw-normal px-2 py-1">{t("customer_feedback")}</span>}
                      </div>
                      <div className="d-flex gap-3">
                        <button
                          className="btn btn-link text-primary text-decoration-none fw-bold p-0 text-13"
                          onClick={() => this.openDetail(item)}
                        >
                          <span className="icon me-1">{"\uf06e"}</span> {t("view_details")}
                        </button>
                        <button
                          className="btn btn-link text-success text-decoration-none fw-bold p-0 text-13"
                          disabled={!item.has_service_report}
                          onClick={() => this.downloadServiceReport(item)}
                        >
                          <span className="icon me-1">{"\uf019"}</span> {t("download_report")}
                        </button>
                      </div>
                    </div>

                  </div>
                </div>
              );
            })}
          </div>

          <div className="d-flex justify-content-between align-items-center p-4 border-top border-light flex-wrap text-secondary text-12 mt-4">
            <div>
              {t("showing")} {count === 0 ? 0 : (page - 1) * PAGE_SIZE + 1}-{(page - 1) * PAGE_SIZE + data.length} {t("of")} {count} {t("service_records")}
            </div>
            <Pagination count={Math.ceil(count / PAGE_SIZE) || 1} page={page} onChange={(_, value) => this.Get(value)} />
          </div>
        </div>

        {/* Service History Detail Modal */}
        <Modal show={modal_view} onHide={this.closeDetail} size="lg" centered contentClassName="border-0 rounded-4 overflow-hidden shadow-lg">
          <Modal.Header className="bg-white border-bottom px-4 py-3">
            <div>
              <h5 className="fw-bold mb-0 text-dark">{view_item?.title || t("service_history_detail")}</h5>
              <div className="text-secondary text-12 font-monospace mt-1">{view_item?.wo_number || "-"}</div>
            </div>
          </Modal.Header>
          <Modal.Body className="p-4" style={{ maxHeight: "70vh", overflowY: "auto" }}>
            {view_loading ? (
              <div className="text-center text-secondary py-5">{t("loading")}</div>
            ) : view_item && (
              <>
                <div className="d-flex align-items-center flex-wrap gap-2 mb-3">
                  <span className={`badge rounded-1 text-10 fw-bold bg-${statusColor(view_item.status)}-light text-${statusColor(view_item.status)}`}>
                    {translateKey(view_item.status)}
                  </span>
                  {view_item.needs_followup && (
                    <span className="badge rounded-1 text-10 fw-bold bg-warning-light text-warning">
                      <span className="icon me-1">{"\uf071"}</span> {t("follow_up_required")}
                    </span>
                  )}
                  <span className="badge bg-light text-secondary rounded-1 text-10 fw-bold border">{translateKey(view_item.type)}</span>
                </div>

                <div className="text-secondary text-13 mb-3">{[view_item.asset_name, view_item.location].filter(Boolean).join(" • ") || "-"}</div>

                <div className="d-flex flex-wrap align-items-center gap-4 mb-3 text-secondary text-12">
                  <span><span className="icon me-1">{"\uf073"}</span> {formatDate(view_item.date) || "-"}</span>
                  <span><span className="icon me-1">{"\uf007"}</span> {view_item.technician_name || "-"}</span>
                  <span><span className="icon me-1">{"\uf017"}</span> {view_item.duration_text || "-"}</span>
                  <span>
                    {view_item.rating === null || view_item.rating === undefined ? (
                      <span className="text-secondary">{t("not_rated")}</span>
                    ) : (
                      <span className="text-warning">
                        <StarRating rating={view_item.rating} size={18} />
                        <span className="text-secondary ms-1 fw-bold">{Number(view_item.rating).toFixed(1)}</span>
                      </span>
                    )}
                  </span>
                </div>

                {view_item.needs_followup && (
                  <div className="bg-warning-light text-warning rounded-3 p-3 mb-3 fw-bold text-13 d-flex align-items-center">
                    <span className="icon me-2">{"\uf071"}</span> {t("follow_up_required")}
                  </div>
                )}

                <div className="bg-light bg-opacity-50 p-3 rounded-3 mb-3">
                  <div className="text-dark fw-bold text-12 mb-1">{t("resolution")}:</div>
                  <div className="text-secondary text-13 lh-base">{view_item.resolution || "-"}</div>
                </div>

                {view_item.root_cause && (
                  <div className="bg-light bg-opacity-50 p-3 rounded-3 mb-3">
                    <div className="text-dark fw-bold text-12 mb-1">{t("root_cause")}:</div>
                    <div className="text-secondary text-13 lh-base">{view_item.root_cause}</div>
                  </div>
                )}

                <div className="mb-3">
                  <div className="text-dark fw-bold text-12 mb-2">{t("parts_used")}</div>
                  {view_item.parts_used_list?.length > 0 ? (
                    <div className="table-responsive">
                      <table className="table table-sm mb-0">
                        <thead>
                          <tr className="text-secondary text-11 fw-bold">
                            <th className="border-0">{t("part_name")}</th>
                            <th className="border-0 text-end">{t("quantity")}</th>
                          </tr>
                        </thead>
                        <tbody>
                          {view_item.parts_used_list.map((part, i) => (
                            <tr key={i}>
                              <td className="text-dark text-13">{part.name || "-"}</td>
                              <td className="text-dark text-13 text-end">{part.quantity}</td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  ) : (
                    <div className="text-secondary text-13">{t("no_parts_used")}</div>
                  )}
                </div>

                <div className="mb-3">
                  <div className="text-dark fw-bold text-12 mb-2">{t("service_photos")}</div>
                  {view_item.photos_list?.length > 0 ? (
                    <div className="row g-2">
                      {view_item.photos_list.map((photo) => (
                        <div className="col-6 col-md-3" key={photo.uid}>
                          <a href={photo.file_path} target="_blank" rel="noreferrer">
                            <img
                              src={photo.file_path}
                              alt={photo.file_name || ""}
                              className="rounded-3 border w-100"
                              style={{ aspectRatio: "1", objectFit: "cover" }}
                            />
                          </a>
                        </div>
                      ))}
                    </div>
                  ) : (
                    <div className="text-secondary text-13">{t("no_photos")}</div>
                  )}
                </div>

                {view_item.feedback && (
                  <div className="bg-light bg-opacity-50 p-3 rounded-3">
                    <div className="text-dark fw-bold text-12 mb-1">{t("customer_feedback")}:</div>
                    <div className="text-secondary text-13 lh-base">{view_item.feedback}</div>
                  </div>
                )}
              </>
            )}
          </Modal.Body>
          <Modal.Footer className="bg-white border-top px-4 py-3">
            <button className="btn btn-white border px-4 py-2 text-dark rounded-3 fw-bold" onClick={this.closeDetail}>
              {t("close")}
            </button>
          </Modal.Footer>
        </Modal>
      </div>
    );
  }
}
